// import React from "react";
// import aboutImage from "../../assets/images/Founder-image/founder.webp";

// const AboutSection = () => {
//   const COLORS = {
//     bgPrimary: "#0B1C2D", // Deep Navy
//     bgSecondary: "#13293D", // Slightly Lighter Navy
//     gold: "#C6A75E", // Premium Gold
//     textLight: "#EAEAEA",
//   };

//   const services = [
//     {
//       id: "01",
//       title: "Corporate Law",
//       desc: "Expert guidance for national and international wealth clients.",
//     },
//     {
//       id: "02",
//       title: "Civil Litigation",
//       desc: "Two decades of mastery in the Supreme Court and High Courts.",
//     },
//     {
//       id: "03",
//       title: "Private Wealth",
//       desc: "Protecting the future of our clients with strategic integrity.",
//     },
//   ];

//   return (
//     <section className="py-12 md:py-20 px-4 md:px-10 ">
//       <div
//         className="max-w-7xl mx-auto overflow-hidden rounded-xl border border-white/10 shadow-2xl relative"
//         style={{ backgroundColor: COLORS.bgSecondary }}
//       >
//         <div className="absolute top-0 right-0 p-10 opacity-[0.03] select-none pointer-events-none">
//           <h1 className="text-[15vw] font-black leading-none">LAW</h1>
//         </div>

//         <div className="flex flex-col lg:flex-row">
//           <div className="lg:w-5/12 relative overflow-hidden group">
//             <img
//               src={aboutImage}
//               alt="Founder"
//               className="w-full h-full min-h-[400px] object-cover"
//             />

//             <div className="absolute inset-0 bg-gradient-to-r from-[#13293D]/20 to-transparent" />

//             <div className="absolute bottom-0 left-0 right-0 p-8 backdrop-blur-sm bg-black/20 border-t border-white/10">
//               <div className="flex items-center gap-4">
//                 <span
//                   className="text-5xl font-bold"
//                   style={{ color: COLORS.gold }}
//                 >
//                   20+
//                 </span>
//                 <p className="text-[10px] uppercase tracking-[0.3em] leading-tight text-white font-semibold">
//                   Years of Unmatched <br />
//                   Legal Mastery
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="lg:w-7/12 p-8 md:p-16 flex flex-col justify-center relative">
//             <div className="flex items-center gap-3 mb-8">
//               <div className="h-[1px] w-8 bg-white/30" />
//               <span
//                 className="text-[11px] font-bold uppercase tracking-[0.5em]"
//                 style={{ color: COLORS.gold }}
//               >
//                 Shailendra Kumar Singh Firm
//               </span>
//             </div>

//             <h2 className="text-4xl md:text-6xl font-bold text-white mb-8 leading-tight">
//               Crafting <span className=" font-light opacity-70">Justice</span>{" "}
//               <br />
//               Through Expertise.
//             </h2>

//             <div className="space-y-6 text-gray-300 max-w-xl">
//               <p
//                 className="text-lg leading-relaxed border-l-2 pl-6"
//                 style={{ borderColor: COLORS.gold }}
//               >
//                 Based in New Delhi, we provide independent, elite legal services
//                 with a focus on strategic integrity and client protection.
//               </p>

//               <div className="grid grid-cols-2 gap-10 py-8 border-y border-white/5">
//                 <div>
//                   <p className="text-4xl font-bold text-white">500+</p>
//                   <p className="text-[20px] uppercase tracking-widest text-gray-400 font-bold">
//                     Success Stories
//                   </p>
//                 </div>
//                 <div>
//                   <p className="text-4xl font-bold text-white">98%</p>
//                   <p className="text-[20px] uppercase tracking-widest text-gray-400 font-bold">
//                     Client Retention
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-12 -mx-8 md:-mx-16 border-t border-white/5">
//               {services.map((s) => (
//                 <div
//                   key={s.id}
//                   className="p-8 hover:bg-white/[0.03] transition-colors border-r border-white/5 last:border-r-0"
//                 >
//                   <span
//                     className="block text-sm font-extrabold mb-4 opacity-90"
//                     style={{
//                       color: COLORS.gold,
//                       fontSize: "1.2rem", // bigger number
//                       textShadow: "0 0 8px rgba(255, 215, 180, 0.6)", // glow effect
//                     }}
//                   >
//                     [{s.id}]
//                   </span>

//                   <h4 className="text-white text-sm sm:text-base font-bold uppercase tracking-wider mb-2">
//                     {s.title}
//                   </h4>

//                   <p className="text-gray-300 text-sm sm:text-[14px] leading-relaxed">
//                     {s.desc}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default AboutSection;

import React from "react";
import aboutImage from "../../assets/images/Founder-image/founder.webp";

const AboutSection = () => {
  return (
    <section className="bg-black text-white py-20 px-6 lg:px-20">

      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">

        {/* ================= LEFT IMAGE ================= */}
        <div className="relative group">

          <div className="rounded-2xl overflow-hidden shadow-2xl">
            <img
              src={aboutImage}
              alt="Founder"
              className="w-full h-[500px] object-cover group-hover:scale-105 transition duration-700"
            />
          </div>

          {/* floating experience card */}
          <div className="absolute -bottom-8 left-6 bg-white text-black px-6 py-4 rounded-xl shadow-xl">
            <p className="text-2xl font-bold text-[#A47148]">25+</p>
            <p className="text-xs uppercase tracking-widest">Years Experience</p>
          </div>

        </div>

        {/* ================= RIGHT CONTENT ================= */}
        <div>

          {/* small heading */}
          <p className="text-sm uppercase tracking-[0.4em] text-[#A47148] mb-6">
            About Advocate
          </p>

          {/* main heading */}
          <h2 className="text-4xl md:text-5xl font-semibold leading-tight mb-6">
            Crafting Justice <br />
            <span className="text-[#A47148]">Through Expertise</span>
          </h2>

          {/* description */}
          <p className="text-gray-400 text-lg leading-relaxed mb-10 max-w-xl">
            Based in New Delhi, we deliver modern legal solutions with precision,
            integrity, and a strong focus on client success.
          </p>

          {/* stats */}
          <div className="flex gap-12 mb-12">
            <div>
              <h3 className="text-3xl font-bold text-[#A47148]">500+</h3>
              <p className="text-sm text-gray-400">Cases Solved</p>
            </div>
            <div>
              <h3 className="text-3xl font-bold text-[#A47148]">98%</h3>
              <p className="text-sm text-gray-400">Client Satisfaction</p>
            </div>
          </div>

          {/* services */}
          <div className="grid md:grid-cols-3 gap-6">

            {[
              {
                title: "Corporate Law",
                desc: "Strategic legal solutions for corporate clients.",
              },
              {
                title: "Civil Litigation",
                desc: "Expert representation in complex court cases.",
              },
              {
                title: "Private Wealth",
                desc: "Protecting assets with long-term legal planning.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="p-6 bg-white/5 rounded-xl border border-white/10 hover:border-[#A47148] hover:bg-white/10 transition-all"
              >
                <h4 className="text-lg font-semibold mb-2">
                  {item.title}
                </h4>
                <p className="text-sm text-gray-400">
                  {item.desc}
                </p>
              </div>
            ))}

          </div>

        </div>

      </div>

    </section>
  );
};

export default AboutSection;